import { render, staticRenderFns } from "./EditOrView.vue?vue&type=template&id=1ad5578c&scoped=true"
import script from "./EditOrView.vue?vue&type=script&lang=js"
export * from "./EditOrView.vue?vue&type=script&lang=js"
import style0 from "./EditOrView.vue?vue&type=style&index=0&id=1ad5578c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad5578c",
  null
  
)

export default component.exports